import { POSITIONS } from "./info";
import { showInfo } from "./info/modal";

const WHATS_NEW_HTML = `
<div style='margin-left: 3vmin; margin-right: 3vmin;'>
    <h2>What's New: Bug Fix 🛠️</h2>
    <p>I've fixed a bug where the teleporter booster was causing issues with level publishing. Now, everything's running smoothly.</p>
    <p>Thank you for your feedback and for helping me improve the game!</p>
</div>
`;

export const showWhatsNew = () => {
  if (WHATS_NEW_HTML)
    showInfo({
      innerHTML: WHATS_NEW_HTML,
      persist: true,
      position: POSITIONS.CENTER,
      closeBtn: true,
    });
};

if (__DEV__) window.showWhatsNew = showWhatsNew;
